import { createFeatureSelector, createSelector } from "@ngrx/store";
import { WALLETS_FEATURE_NAME, WalletsState } from "./wallets.reducer";

export const selectorWalletsState = createFeatureSelector<WalletsState>(WALLETS_FEATURE_NAME);

export const selectorWalletOverview = createSelector(selectorWalletsState, (state) => state.walletOverview.data);
export const selectorWalletOverviewStatus = createSelector(selectorWalletsState, (state) => state.walletOverview.status);
export const selectorWalletOverviewError = createSelector(selectorWalletsState, (state) => state.walletOverview.error);

export const selectorPaymentWallets = createSelector(selectorWalletsState, (state) => state.paymentWallets.data);
export const selectorPaymentWalletsStatus = createSelector(selectorWalletsState, (state) => state.paymentWallets.status);
export const selectorPaymentWalletsError = createSelector(selectorWalletsState, (state) => state.paymentWallets.error);

export const selectorBeneficiary = createSelector(selectorWalletsState, (state) => state.beneficiary.data);
export const selectorBeneficiaryStatus = createSelector(selectorWalletsState, (state) => state.beneficiary.status);
export const selectorBeneficiaryError = createSelector(selectorWalletsState, (state) => state.beneficiary.error);

export const selectorWalletTransactions = createSelector(selectorWalletsState, (state) => state.walletTransactions.data);
export const selectorWalletTransactionsStatus = createSelector(selectorWalletsState, (state) => state.walletTransactions.status);
export const selectorWalletTransactionsError = createSelector(selectorWalletsState, (state) => state.walletTransactions.error);

export const selectorPaymentPayouts = createSelector(selectorWalletsState, (state) => state.paymentPayouts.data);
export const selectorPaymentPayoutsStatus = createSelector(selectorWalletsState, (state) => state.paymentPayouts.status);
export const selectorPaymentPayoutsError = createSelector(selectorWalletsState, (state) => state.paymentPayouts.error);

export const selectorPayoutParam = createSelector(selectorWalletsState, (state) => state.payoutParam.data);
export const selectorPayoutParamStatus = createSelector(selectorWalletsState, (state) => state.payoutParam.status);
export const selectorPayoutParamError = createSelector(selectorWalletsState, (state) => state.payoutParam.error);

export const selectorValidatePayoutBeneficiary = createSelector(selectorWalletsState, (state) => state.validatePayoutBeneficiary.data);
export const selectorValidatePayoutBeneficiaryStatus = createSelector(selectorWalletsState, (state) => state.validatePayoutBeneficiary.status);
export const selectorValidatePayoutBeneficiaryError = createSelector(selectorWalletsState, (state) => state.validatePayoutBeneficiary.error);
export const selectorValidatePayoutBeneficiaryFailureKind = createSelector(
  selectorWalletsState,
  (state) => state.validatePayoutBeneficiary.failureKind
);
